/**
 * @packageDocumentation
 * @module Auth
 * @category Core
 */

/**
 * Заголовок, который необходимо указать в запросе для пропуска интерсептора с добавлением токена авторизации
 *
 * @example
 *
 * ```ts
 * this.apollo.query({
 *     query,
 *     variables,
 *     context: {
 *       headers: new HttpHeaders().append(SKIP_TOKEN_INTERCEPTOR_HEADER, ''),
 *     },
 * });
 * ```
 *
 * @group Consts
 */
export const SKIP_TOKEN_INTERCEPTOR_HEADER = 'Skip-Token-Interceptor';
